<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-11-30 08:52:53
 * @LastEditTime : 2023-12-22 10:45:59
 * @LastEditors  : yangxr
 * @Description  : 收款计划弹窗
 * @FilePath     : \icps_fb\src\views\platform\ICPS\internetSales\components\skPlan.vue
-->
<template>
  <el-dialog title="选择" append-to-body :visible="visible" width="1230px" @close="onClose" @open="onOpen">
    <div class="card">
      <div class="card_nav">
        <div>
          <el-button size="small" class="bottom_all" style="margin-left: 0" @click="initForm(), addFromDate('添加')">
            <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
            添加
          </el-button>
        </div>
      </div>
      <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark" highlight-current-row>
        <el-table-column label="资金计划" width="auto" align="center">
          <el-table-column prop="paymentDate" label="收款日期" width="auto" align="center"></el-table-column>
          <el-table-column label="当月资金" width="auto" align="center">
            <el-table-column prop="thisMonthPaymentForm" label="收款形式" width="auto" align="center"></el-table-column>
            <el-table-column prop="thisMonthMoney" label="账款金额" width="auto" align="center"></el-table-column>
            <el-table-column prop="thisMonthReceiptDate" label="预计到账时间" width="150" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="跨月资金" width="auto" align="center">
            <el-table-column prop="lastMonthPaymentForm" label="收款形式" width="auto" align="center"></el-table-column>
            <el-table-column prop="lastMonthMoney" label="账款金额" width="auto" align="center"></el-table-column>
            <el-table-column prop="lastMonthReceiptDate" label="预计到账时间" width="150" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="承诺资金" width="auto" align="center">
            <el-table-column prop="commitmentPaymentForm" label="收款形式" width="auto" align="center"></el-table-column>
            <el-table-column prop="commitmentMoney" label="账款金额" width="auto" align="center"></el-table-column>
            <el-table-column prop="commitmentReceiptDate" label="预计到账时间" width="150" align="center"></el-table-column>
          </el-table-column>
          <el-table-column label="其他" width="auto" align="center">
            <el-table-column prop="createUserName" label="创建人" width="auto" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="150" align="center"></el-table-column>
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="scope">
                <el-button style="margin: 5px 0" class="bottom_one" size="mini" @click="changeSkPlan(scope.row)"> 修改 </el-button>
                <el-button class="bottom_all_two" size="mini" @click="deletePlan(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="params.page" :page-size="params.pageSize" layout="total, prev, pager, next, jumper" :total="total" @current-change="queryPagePlan()"></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="onClose">取 消</el-button>
      <el-button class="bottom_all" type="primary" @click="onConfirm">确 定</el-button>
    </span>
    <!-- 添加 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="760px" :close-on-click-modal="false" append-to-body :before-close="resetFormData">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div>
        <el-form ref="refformData" :rules="rules" :inline="true" :model="formData" label-width="110px">
          <el-form-item prop="paymentDate" class="zq">
            <span slot="label">收款日期</span>
            <el-date-picker v-model="formData.paymentDate" style="width: 230px" type="month" placeholder="选择日期" value-format="yyyy-MM"> </el-date-picker>
          </el-form-item>
          <div class="form-title">当月资金</div>
          <el-form-item prop="thisMonthPaymentFormId">
            <span slot="label">收款形式</span>
            <el-select
              ref="thisMonthPaymentFormId"
              v-model="formData.thisMonthPaymentFormId"
              placeholder="请选择"
              :disabled="modifyType"
              style="width: 230px"
              @change="
                $nextTick(() => {
                  formData.thisMonthPaymentForm = $refs.thisMonthPaymentFormId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in collectionTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="thisMonthMoney">
            <span slot="label">收款金额</span>
            <el-input v-model="formData.thisMonthMoney" style="width: 230px" :disabled="modifyType" type="number">
              <template slot="append">万元</template>
            </el-input>
          </el-form-item>
          <el-form-item prop="thisMonthReceiptDate">
            <span slot="label">预计到账日期</span>
            <el-date-picker v-model="formData.thisMonthReceiptDate" style="width: 230px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <div class="form-title">跨月资金</div>
          <el-form-item prop="lastMonthPaymentFormId">
            <span slot="label">收款形式</span>
            <el-select
              ref="lastMonthPaymentFormId"
              v-model="formData.lastMonthPaymentFormId"
              placeholder="请选择"
              :disabled="modifyType"
              style="width: 230px"
              @change="
                $nextTick(() => {
                  formData.lastMonthPaymentForm = $refs.lastMonthPaymentFormId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in collectionTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="lastMonthMoney">
            <span slot="label">收款金额</span>
            <el-input v-model="formData.lastMonthMoney" style="width: 230px" :disabled="modifyType" type="number"><template slot="append">万元</template></el-input>
          </el-form-item>
          <el-form-item prop="lastMonthReceiptDate">
            <span slot="label">预计到账日期</span>
            <el-date-picker v-model="formData.lastMonthReceiptDate" style="width: 230px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <div class="form-title">承诺资金</div>
          <el-form-item prop="commitmentPaymentFormId">
            <span slot="label">收款形式</span>
            <el-select
              ref="commitmentPaymentFormId"
              v-model="formData.commitmentPaymentFormId"
              placeholder="请选择"
              :disabled="modifyType"
              style="width: 230px"
              @change="
                $nextTick(() => {
                  formData.commitmentPaymentForm = $refs.commitmentPaymentFormId.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in collectionTypeList" :key="index" :label="item.itemName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="commitmentMoney">
            <span slot="label">收款金额</span>
            <el-input v-model="formData.commitmentMoney" style="width: 230px" :disabled="modifyType" type="number"><template slot="append">万元</template></el-input>
          </el-form-item>
          <el-form-item prop="commitmentReceiptDate">
            <span slot="label">预计到账日期</span>
            <el-date-picker v-model="formData.commitmentReceiptDate" style="width: 230px" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFormData">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitFormData()">确定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { queryPagePlan, saveOrUpdatePlan, deletePlan } from "@/api/internetSales/performanceRecord.js";
import { getDicType } from "@/api/common.js";
export default {
  data() {
    return {
      radio: null, // 单选框
      select: {}, // 选择的数据
      tableData: [], // 表格数据
      params: {
        page: 1,
        pageSize: 10,
        enginnerId: "",
      },
      total: 0,
      formData: {},
      rules: {
        paymentDate: [{ required: true, message: "请选择收款日期", trigger: "change" }],
        thisMonthPaymentFormId: [{ required: true, message: "请选择收款形式", trigger: "change" }],
        thisMonthMoney: [{ required: true, message: "请输入收款金额", trigger: "bulr" }],
      },
      collectionTypeList: [],
      modifyType: false,
      addDialog: false,
      addDialogTitle: "",
    };
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    // 控制dialog显示
    visible: {
      type: Boolean,
    },
  },
  mounted() {
    getDicType({ code: "SHOUKUANXINGSHI" }).then(res => {
      this.collectionTypeList = res.data.items; //
    });
  },
  methods: {
    changeSkPlan(row) {
      this.formData = row;
      this.addDialogTitle = "修改";
      this.addDialog = true;
    },
    deletePlan(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deletePlan({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功!");
              this.queryPagePlan();
            }
          });
        })
        .catch(() => {});
    },
    submitFormData() {
      this.$refs.refformData.validate(valid => {
        if (valid) {
          saveOrUpdatePlan(this.formData).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
              this.queryPagePlan();
              this.addDialog = false;
            }
          });
        } else {
          this.$message({
            message: "必填字段填写不完全！",
            type: "warning",
          });
          return false;
        }
      });
    },
    initForm() {
      this.formData = {
        id: "",
        enginnerId: this.config.id, //工程id
        paymentDate: "", //收款日期(年月)
        lastMonthMoney: "", //跨月资金-收款金额
        lastMonthPaymentForm: "", //跨月资金-收款形式（字典）
        lastMonthPaymentFormId: "", //跨月资金-收款形式（字典）id
        lastMonthReceiptDate: "", //跨月资金-预计到账日期,年月日
        commitmentMoney: "", //承诺资金-收款金额(最多2位)
        commitmentPaymentForm: "", //承诺资金-收款形式（字典）
        commitmentPaymentFormId: "", //承诺资金-收款形式（字典）id
        commitmentReceiptDate: "", //承诺资金-预计到账日期,年月日
        thisMonthMoney: "", //当月资金-收款金额
        thisMonthPaymentForm: "", //当月资金-收款形式（字典）
        thisMonthPaymentFormId: "", //当月资金-收款形式（字典）id
        thisMonthReceiptDate: "", //当月资金-预计到账日期,年月日
      };
    },
    resetFormData() {
      this.initForm();
      this.addDialog = false;
    },
    addFromDate(text) {
      (this.addDialog = true), (this.addDialogTitle = text);
    },
    // 原物料单选列表查询
    queryPagePlan() {
      this.params.enginnerId = this.config.id;
      queryPagePlan(this.params).then(res => {
        this.tableData = res.data.data;
        this.total = res.data.totalRows;
      });
    },
    onOpen() {
      this.queryPagePlan();
    },
    onClose() {
      this.$emit("update:visible", false);
    },
    onConfirm() {
      this.$emit("updated", this.select);
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>
